export const CALC_TEXT_DEFAULTS = {
  label_consumption: "Consommation actuelle (L/100km)",
  label_km: "Kilométrage annuel",
  label_sp95: "Prix SP95/SP98 actuel",
  label_e85: "Prix E85",
  button_text: "Calculer mes économies",
  result_annual: "Économie annuelle",
  result_percent_suffix: "sur le carburant",
  result_monthly: "Économie mensuelle",
  result_monthly_suffix: "par mois",
  result_cost: "Coût annuel carburant",
  note: "Le calcul prend en compte une surconsommation moyenne de 25% avec l'E85. La consommation réelle peut varier selon le véhicule et le style de conduite.",
  cta_text: "Prendre RDV pour ma conversion",
};

export const CALC_TEXT_FIELDS = [
  ["label_consumption", "Libellé — consommation"],
  ["label_km", "Libellé — kilométrage"],
  ["label_sp95", "Libellé — prix SP95/SP98"],
  ["label_e85", "Libellé — prix E85"],
  ["button_text", "Bouton « Calculer »"],
  ["result_annual", "Résultat — titre économie annuelle"],
  ["result_percent_suffix", "Résultat — texte après le % (ex. « sur le carburant »)"],
  ["result_monthly", "Résultat — titre économie mensuelle"],
  ["result_monthly_suffix", "Résultat — texte sous l'économie mensuelle"],
  ["result_cost", "Résultat — titre coût annuel carburant"],
  ["note", "Note sous les résultats", true],
  ["cta_text", "Bouton de réservation"],
];
